import books from "../../data/Books.json";
import monographs from "../../data/Monographs.json";
import React from "react";
import "../../styles/Book.css";
import { useState, useEffect } from "react";
const BookList = () => {
  const [booksData, setBooks] = useState({ books: [] });
  const [monographsData, setMonographs] = useState({ monographs: [] });
  const [error, setError] = useState(null);

  useEffect(() => {
    try {
      setBooks(books);
      setMonographs(monographs);
    } catch (err) {
      setError(err.message);
    }
  }, []);

  if (error) return <p>Error: {error}</p>;
  if (!booksData || !monographsData) return <p>Loading...</p>;

  return (
    <div className="book-list-container">
      <h2>Monographs</h2>
      <div className="monographs">
        <ol>
          {monographsData.monographs.map((entry, index) => (
            <li key={index}>{entry}</li>
          ))}
        </ol>
      </div>

      <h2 className="book-list-title">Books</h2>
      <div className="book-grid">
        {booksData.books.map((book, index) => (
          <div key={index} className="book-card">
            <img src={book.image} alt={book.title} className="book-image" />
            <div className="book-info">
              <h3 className="book-title">{book.title}</h3>
              <p className="book-author">{book.author}</p>
              {book.pages && <p className="book-pages">Pages: {book.pages}</p>}
              {book.ISBN && <p className="book-isbn">ISBN: {book.ISBN}</p>}
              {book.publisher && (
                <p className="book-publisher">Publisher: {book.publisher}</p>
              )}
              {book.links && (
                <div className="book-links">
                  {book.links.paperback && (
                    <a
                      href={book.links.paperback}
                      target="_blank"
                      rel="noreferrer"
                    >
                      Paperback
                    </a>
                  )}
                  {book.links.hardcover && (
                    <a
                      href={book.links.hardcover}
                      target="_blank"
                      rel="noreferrer"
                    >
                      Hardcover
                    </a>
                  )}
                  {book.links.amazon_es && (
                    <a
                      href={book.links.amazon_es}
                      target="_blank"
                      rel="noreferrer"
                    >
                      Amazon ES
                    </a>
                  )}
                  {book.links.amazon_com && (
                    <a
                      href={book.links.amazon_com}
                      target="_blank"
                      rel="noreferrer"
                    >
                      Amazon US
                    </a>
                  )}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default BookList;
